/* eslint-disable unused-imports/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
/**
 * Generated by orval v7.20.0 🍺
 * Do not edit manually.
 * Content Guide API
 * Documentation of the controllers and endpoints used in the content-service.
 * OpenAPI spec version: deploy-only-BS-816-2480
 */
import type {
  GetContentFromElasticSearchServerParams,
  GetSearchContentSuggestionParams,
  GetSearchContentSuggestionServerParams,
  PagedContentAbstractDocument,
} from '@as-react/common-types/content-service';
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useCallback } from 'react';

import { queryFetch } from '../../utils/orval/queryFetch';
import type { ErrorType } from '../../utils/orval/queryFetch';
import { queryKeyMutator } from '../../utils/orval/queryKeyMutator';
import { useQueryFetch } from '../../utils/orval/useQueryFetch';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Search content based on parameters
 * @deprecated
 */
export const getContentFromElasticSearchServer = (
  params: GetContentFromElasticSearchServerParams,
  operationName = 'getContentFromElasticSearch',
  options?: SecondParameter<typeof queryFetch>,
  signal?: AbortSignal
) => {
  return queryFetch<PagedContentAbstractDocument>(
    { url: `/content/search`, method: 'GET', params, signal },
    { operationName: 'getContentFromElasticSearch', ...options }
  );
};

export const useGetContentFromElasticSearchServerQueryOptions = <
  TData = Awaited<ReturnType<typeof getContentFromElasticSearchServer>>,
  TError = ErrorType<unknown>,
>(
  params: GetContentFromElasticSearchServerParams,
  operationName = 'getContentFromElasticSearch',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getContentFromElasticSearchServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator({ params, operationName }, { url: `/content/search`, queryOptions });

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getContentFromElasticSearchServer>>> = ({ signal }) =>
    getContentFromElasticSearchServer(params, operationName, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getContentFromElasticSearchServer>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetContentFromElasticSearchServerQueryResult = NonNullable<
  Awaited<ReturnType<typeof getContentFromElasticSearchServer>>
>;
export type GetContentFromElasticSearchServerQueryError = ErrorType<unknown>;

export function useGetContentFromElasticSearchServer<
  TData = Awaited<ReturnType<typeof getContentFromElasticSearchServer>>,
  TError = ErrorType<unknown>,
>(
  params: GetContentFromElasticSearchServerParams,
  operationName: undefined | string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getContentFromElasticSearchServer>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getContentFromElasticSearchServer>>,
          TError,
          Awaited<ReturnType<typeof getContentFromElasticSearchServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetContentFromElasticSearchServer<
  TData = Awaited<ReturnType<typeof getContentFromElasticSearchServer>>,
  TError = ErrorType<unknown>,
>(
  params: GetContentFromElasticSearchServerParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getContentFromElasticSearchServer>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getContentFromElasticSearchServer>>,
          TError,
          Awaited<ReturnType<typeof getContentFromElasticSearchServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetContentFromElasticSearchServer<
  TData = Awaited<ReturnType<typeof getContentFromElasticSearchServer>>,
  TError = ErrorType<unknown>,
>(
  params: GetContentFromElasticSearchServerParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getContentFromElasticSearchServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @deprecated
 */

export function useGetContentFromElasticSearchServer<
  TData = Awaited<ReturnType<typeof getContentFromElasticSearchServer>>,
  TError = ErrorType<unknown>,
>(
  params: GetContentFromElasticSearchServerParams,
  operationName = 'getContentFromElasticSearch',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getContentFromElasticSearchServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useGetContentFromElasticSearchServerQueryOptions(params, operationName, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const useGetSearchContentSuggestionHook = () => {
  const getSearchContentSuggestion = useQueryFetch<PagedContentAbstractDocument>();

  return useCallback(
    (
      params: GetSearchContentSuggestionParams,
      operationName = 'getSearchContentSuggestion',
      options?: SecondParameter<ReturnType<typeof useQueryFetch>>,
      signal?: AbortSignal
    ) => {
      return getSearchContentSuggestion(
        { url: `/api/aem/search/suggestion/content`, method: 'GET', params, signal },
        { operationName: 'getSearchContentSuggestion', ...options }
      );
    },
    [getSearchContentSuggestion]
  );
};

export const useGetSearchContentSuggestionQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetSearchContentSuggestionHook>>>,
  TError = ErrorType<unknown>,
>(
  params: GetSearchContentSuggestionParams,
  operationName = 'getSearchContentSuggestion',
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSearchContentSuggestionHook>>>, TError, TData>
    >;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator(
    { params, operationName },
    { url: `/api/aem/search/suggestion/content`, queryOptions }
  );

  const getSearchContentSuggestion = useGetSearchContentSuggestionHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetSearchContentSuggestionHook>>>> = ({
    signal,
  }) => getSearchContentSuggestion(params, operationName, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetSearchContentSuggestionHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSearchContentSuggestionQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetSearchContentSuggestionHook>>>
>;
export type GetSearchContentSuggestionQueryError = ErrorType<unknown>;

export function useGetSearchContentSuggestion<
  TData = Awaited<ReturnType<ReturnType<typeof useGetSearchContentSuggestionHook>>>,
  TError = ErrorType<unknown>,
>(
  params: GetSearchContentSuggestionParams,
  operationName: undefined | string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSearchContentSuggestionHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetSearchContentSuggestionHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetSearchContentSuggestionHook>>>
        >,
        'initialData'
      >;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSearchContentSuggestion<
  TData = Awaited<ReturnType<ReturnType<typeof useGetSearchContentSuggestionHook>>>,
  TError = ErrorType<unknown>,
>(
  params: GetSearchContentSuggestionParams,
  operationName?: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSearchContentSuggestionHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetSearchContentSuggestionHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetSearchContentSuggestionHook>>>
        >,
        'initialData'
      >;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSearchContentSuggestion<
  TData = Awaited<ReturnType<ReturnType<typeof useGetSearchContentSuggestionHook>>>,
  TError = ErrorType<unknown>,
>(
  params: GetSearchContentSuggestionParams,
  operationName?: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSearchContentSuggestionHook>>>, TError, TData>
    >;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetSearchContentSuggestion<
  TData = Awaited<ReturnType<ReturnType<typeof useGetSearchContentSuggestionHook>>>,
  TError = ErrorType<unknown>,
>(
  params: GetSearchContentSuggestionParams,
  operationName = 'getSearchContentSuggestion',
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSearchContentSuggestionHook>>>, TError, TData>
    >;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useGetSearchContentSuggestionQueryOptions(params, operationName, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getSearchContentSuggestionServer = (
  params: GetSearchContentSuggestionServerParams,
  operationName = 'getSearchContentSuggestion',
  options?: SecondParameter<typeof queryFetch>,
  signal?: AbortSignal
) => {
  return queryFetch<PagedContentAbstractDocument>(
    { url: `/content/autosuggest`, method: 'GET', params, signal },
    { operationName: 'getSearchContentSuggestion', ...options }
  );
};

export const useGetSearchContentSuggestionServerQueryOptions = <
  TData = Awaited<ReturnType<typeof getSearchContentSuggestionServer>>,
  TError = ErrorType<unknown>,
>(
  params: GetSearchContentSuggestionServerParams,
  operationName = 'getSearchContentSuggestion',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSearchContentSuggestionServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator({ params, operationName }, { url: `/content/autosuggest`, queryOptions });

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSearchContentSuggestionServer>>> = ({ signal }) =>
    getSearchContentSuggestionServer(params, operationName, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSearchContentSuggestionServer>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSearchContentSuggestionServerQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSearchContentSuggestionServer>>
>;
export type GetSearchContentSuggestionServerQueryError = ErrorType<unknown>;

export function useGetSearchContentSuggestionServer<
  TData = Awaited<ReturnType<typeof getSearchContentSuggestionServer>>,
  TError = ErrorType<unknown>,
>(
  params: GetSearchContentSuggestionServerParams,
  operationName: undefined | string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSearchContentSuggestionServer>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSearchContentSuggestionServer>>,
          TError,
          Awaited<ReturnType<typeof getSearchContentSuggestionServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSearchContentSuggestionServer<
  TData = Awaited<ReturnType<typeof getSearchContentSuggestionServer>>,
  TError = ErrorType<unknown>,
>(
  params: GetSearchContentSuggestionServerParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSearchContentSuggestionServer>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSearchContentSuggestionServer>>,
          TError,
          Awaited<ReturnType<typeof getSearchContentSuggestionServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSearchContentSuggestionServer<
  TData = Awaited<ReturnType<typeof getSearchContentSuggestionServer>>,
  TError = ErrorType<unknown>,
>(
  params: GetSearchContentSuggestionServerParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSearchContentSuggestionServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetSearchContentSuggestionServer<
  TData = Awaited<ReturnType<typeof getSearchContentSuggestionServer>>,
  TError = ErrorType<unknown>,
>(
  params: GetSearchContentSuggestionServerParams,
  operationName = 'getSearchContentSuggestion',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSearchContentSuggestionServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useGetSearchContentSuggestionServerQueryOptions(params, operationName, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
